<template>
    <div v-if="model">
        <v-text-field
            label="Название"
            v-model="model.name"
            :error-messages="errorsFor('name')"
        />
    </div>
</template>

<script lang="ts">
import {Component} from 'vue-property-decorator'
import {createDeviceGroup, DeviceGroupDraft} from '@/models/DeviceGroup'
import Form from '@/mixins/Form'

@Component({
    components: {},
})
export default class DeviceGroupForm extends Form<DeviceGroupDraft>
{
    createModel(): DeviceGroupDraft {
        return createDeviceGroup()
    }
}
</script>
